import {api} from '../../constants/api';
import axios from 'axios';

export const addCustomer = async (
  shumaID,
  firstName,
  lastName,
  phone,
  email,
  customerType,
  idNumber,
  genderID,
  address,
  status,
) => {
  const data = {
    customerID: -1,
    shumaID,
    firstName,
    lastName,
    phone,
    email,
    customerType,
    idNumber,
    genderID,
    address,
    status,
  };
  const result = await axios.post(api.ADD_EDIT_CUSTOMER, data);
  if (result.data.errorCode !== 0) throw new Error(`API error: ${result.data.errorCode}`);
  return result.data.body.customerData;
};